import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface ModelDataUser {
  NombreUsuario: string;
  pass: string;
  ActiveDirectoryGroup: string;
}


@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {
  USUARIO_LISTACLIENTES: Array<any>;
  USUARIO_OPERADORLOGGED: Array<any>;
  USUARIO_LISTAPERFILES: Array<any>;
  errorMensaje: string;
  token: string;
  httpOptionsLogin;
  constructor(private http: HttpClient) {
    this.httpOptionsLogin = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8'
      })
    };
  }
  URL_InspeccionTotal = `${environment.URL_InspeccionTotal}`;
  URL_Token = `${environment.URL_Token}`;

  public handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {

    } else {
      alert('No hay datos para la consulta');
    }
    this.errorMensaje = 'Error; por favor intente más tarde';
    return throwError('Error; por favor intente más tarde.');
  }

  autenticar(username: string, password: string) {
    let datoLogin = { username: username, password: window.atob(password) };
    let respuesta = this.http.post(this.URL_Token, datoLogin, this.httpOptionsLogin)
    return respuesta
  }

  getUsername(Username: string) {
    this.token = localStorage.getItem('token');
    var httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + this.token
      })
    };
    return this.http.get(this.URL_InspeccionTotal + 'v1/users/username/' + Username, httpOptions)
  }
  /*  */
  sendEmailForgotPassword(Username: string) {
    var httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8'
      })
    };
    return this.http.get(`${this.URL_InspeccionTotal}v1/password/forgetPassword/${Username}`, httpOptions)
  }
  /*  */
  getTermsConditions(username: string) {
    this.token = localStorage.getItem('token');
    var httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + this.token
      })
    };
    return this.http.get(this.URL_InspeccionTotal + 'v1/users/aceptarTerminosYCondiciones/' + username, httpOptions)
  };
}

